export default __webpack_public_path__ + "static/media/westfield-app.inline.5fea8b14.svg";